import { httpClient } from "../../httpClient";

type Settings = {
  sendChatAlert: boolean;
};

export async function getSettings(): Promise<Settings> {
  try {
    const { data } = await httpClient.get<Settings>(`/api/v1/user/settings`);

    return data;
  } catch (error) {
    throw error;
  }
}

export async function putSettings(payload: Settings): Promise<Settings> {
  try {
    const { data } = await httpClient.put<Settings>(
      `/api/v1/user/settings`,
      payload
    );

    return data;
  } catch (error) {
    throw error;
  }
}
